import { createFileRoute } from '@tanstack/react-router'

import { EmailDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-documentation/email-documentation-page.tsx'

export const Route = createFileRoute('/bo/documentation/emails')({
  component: () => <EmailDocumentationPage />,
})
